import { render, staticRenderFns } from "./NsLogo.vue?vue&type=template&id=466f2bee&scoped=true&"
import script from "./NsLogo.vue?vue&type=script&lang=js&"
export * from "./NsLogo.vue?vue&type=script&lang=js&"
import style0 from "./NsLogo.vue?vue&type=style&index=0&id=466f2bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466f2bee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('466f2bee')) {
      api.createRecord('466f2bee', component.options)
    } else {
      api.reload('466f2bee', component.options)
    }
    module.hot.accept("./NsLogo.vue?vue&type=template&id=466f2bee&scoped=true&", function () {
      api.rerender('466f2bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsLogo.vue"
export default component.exports